export enum Locales {
  PT_BR = "pt-BR",
  ES_PY = "es-PY",
}

export const DEFAULT_LOCALE = Locales.PT_BR;

export const SUPPORTED_LANGUAGES: Record<
  Locales,
  { displayName: string; name: string }
> = {
  [Locales.PT_BR]: {
    displayName: "Português (Brasil)",
    name: "Português",
  },
  [Locales.ES_PY]: {
    displayName: "Español (Paraguay)",
    name: "Español",
  },
};
